interface ButtonProps {
    className: string;
    disable?: boolean;
    btnName: string;
    onClick: () => void;
}

export default function Button({ onClick, className, disable = false, btnName }: ButtonProps) {
    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disable}
        >
            {btnName}
        </button>
    )
}
